import { render, staticRenderFns } from "./PolicyDocumentManage.vue?vue&type=template&id=3448650a&"
import script from "./PolicyDocumentManage.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports